import useModalsStore from "src/store/modalsStore";
import Modal from "../Modal/Modal";
import { QRCodeSVG } from "qrcode.react";
import { MdClose, MdEdit, MdShare } from "react-icons/md";
import { useTranslation } from "react-i18next";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import { useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import useCurrentUser from "src/hooks/useCurrentUser";
import clsx from "clsx";
import { ROUTES } from "src/helpers/routes";
import { getQrCodeDataByUser } from "src/helpers/utils";
import { ICON_SIZES } from "src/constants/icons";
import { EButtonKind } from "../Button/Button.types";

const CurrentUserQrContact: React.FC = () => {
  const { setShowContactQrCode } = useModalsStore();
  const { userInfo } = useCurrentUser();
  const location = useLocation();

  const { t } = useTranslation(["common", "modals"]);
  const navigate = useNavigate();

  const qrValue = useMemo(() => {
    return getQrCodeDataByUser(userInfo);
  }, [userInfo]);

  return (
    <Modal
      onEscape={() => setShowContactQrCode(false)}
      className="md:!max-w-[430px] md:!w-full"
    >
      <Modal.Header
        title={t("modals:share_contact_info.title")}
        onClose={() => setShowContactQrCode(false)}
      />
      <Modal.Body>
        <div
          className={clsx([
            "flex",
            "flex-col",
            "items-center",
            "justify-center",
            "gap-4",
          ])}
        >
          <p className="text-sm">{t("modals:share_contact_info.top_text")}</p>
          <div className={clsx(["flex", "justify-center", "items-center"])}>
            <QRCodeSVG
              value={qrValue}
              title="eXpenser.net"
              fgColor="#212f3c"
              height={180}
              width={180}
              level="L"
            />
          </div>
          <p className="text-sm">
            {t("modals:share_contact_info.bottom_text")}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer
        actions={[
          {
            text: t("common:buttons.close"),
            icon: <MdClose size={ICON_SIZES.SM} />,
            onClick: () => setShowContactQrCode(false),
            kind: EButtonKind.NORMAL,
          },
        ]}
        leftContent={
          <ButtonGroup
            gap={1}
            align="left"
            buttons={[
              {
                tooltip: t("common:tooltips.share"),
                onClick: () => {},
                icon: <MdShare size={ICON_SIZES.SM} />,
                kind: EButtonKind.NORMAL,
              },
              {
                tooltip: t("common:tooltips.edit"),
                onClick: () => {
                  setShowContactQrCode(false);
                  navigate(ROUTES.SETTINGS_PROFILE);
                },
                icon: <MdEdit size={ICON_SIZES.SM} />,
                hide: location.pathname.startsWith(ROUTES.SETTINGS_PROFILE),
                kind: EButtonKind.EDIT,
              },
            ]}
          />
        }
      />
    </Modal>
  );
};

export default CurrentUserQrContact;
